























import Vue from 'vue'
import StatusBadge from '@/components/sub-components/StatusBadge.vue'
import { InhalerTypes } from '@/jsonapi/CommonTypes'

export default Vue.extend({
  components: {
    StatusBadge,
  },
  props: {
    inhalerUsages: {
      type: Array,
      default: () => [],
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    maintenanceInhalerUsages() {
      return this.inhalerUsages.filter(usage => usage.type === InhalerTypes.Maintenance)
    },
    rescueInhalerUsages() {
      return this.inhalerUsages.filter(usage => usage.type === InhalerTypes.Reliever)
    },
  },
})
